import * as tests from 'global/passwordStrength/passwordStrengthRules';

class PasswordStrength {
	constructor(passwordWrap) {
		this.wrap = passwordWrap;
		this.passwordInput = this.wrap.querySelector('#password');

		this.strengthMsg = this.wrap.querySelector(
			'[data-password-strength-indicator]',
		);
		this.strengthAsText = this.wrap.querySelector(
			'[data-password-strength-text]',
		);
		this.strengthTextWeak = this.strengthAsText.dataset.passwordTextWeak || '';
		this.strengthTextMedium =
			this.strengthAsText.dataset.passwordTextMedium || '';
		this.strengthTextStrong =
			this.strengthAsText.dataset.passwordTextStrong || '';
		this.showStrengthIndicatorClass =
			'toggle-password__password-strength-text--show';

		this.passwordBar = this.createPasswordBar();
		this.passwordBarStrength = this.createPasswordBarStrength();

		this.colorWeak = '#e4002c';
		this.colorMedium = '#fb3';
		this.colorStrong = '#00a66e';

		this.result = {
			scorePercentage: 0,
			maxScore: 90,
		};

		this.options = {
			weak: {
				strength: 0,
				color: this.colorWeak,
				text: this.strengthTextWeak,
			},
			medium: {
				strength: 33,
				color: this.colorMedium,
				text: this.strengthTextMedium,
			},
			strong: {
				strength: 66,
				color: this.colorStrong,
				text: this.strengthTextStrong,
			},
		};

		this.addEventsListeners();
		this.subscribeToPasswordRulesState();
	}

	createPasswordBar() {
		const passwordBar = document.createElement('div');
		passwordBar.className = 'password-strength__bar';

		this.strengthMsg.parentNode.insertBefore(passwordBar, this.strengthMsg);

		return passwordBar;
	}

	createPasswordBarStrength() {
		const passwordBarStrength = document.createElement('span');
		passwordBarStrength.className = 'password-strength__bar-strength';

		this.passwordBar.appendChild(passwordBarStrength);

		return passwordBarStrength;
	}

	addEventsListeners() {
		this.passwordInput.addEventListener('keyup', () =>
			this.updatePasswordStrength(),
		);
		this.passwordInput.addEventListener('change', () =>
			this.updatePasswordStrength(),
		);
		this.passwordInput.addEventListener('paste', () =>
			this.updatePasswordStrength(),
		);
	}

	updatePasswordStrength() {
		this.result.scorePercentage = this.scoreCalculation();
		this.strengthBarAnimate();
		this.showStrengthText();
	}

	scoreCalculation() {
		const { value } = this.passwordInput;

		const score = Object.keys(tests).reduce(
			(prev, curr) => prev + tests[curr](value),
			0,
		);
		const scorePercentage = Math.floor((score / this.result.maxScore) * 100);

		return value.length === 0 ? 0 : scorePercentage;
	}

	strengthBarAnimate() {
		this.strengthBreaks();
		this.passwordBarStrength.style.width = `${this.result.scorePercentage}%`;
	}

	strengthBreaks() {
		const { weak, medium, strong } = this.options;
		const { scorePercentage } = this.result;

		let backgroundColor = weak.color;
		this.strengthAsText.innerText = weak.text;

		if (scorePercentage >= strong.strength) {
			backgroundColor = strong.color;
			this.strengthAsText.innerText = strong.text;
		} else if (scorePercentage >= medium.strength) {
			backgroundColor = medium.color;
			this.strengthAsText.innerText = medium.text;
		}

		this.passwordBarStrength.style.background = backgroundColor;
	}

	subscribeToPasswordRulesState() {
		window.od.events.subscribe('password-rules-state', haveRulesPassed =>
			this.setStrengthOptions(haveRulesPassed),
		);
	}

	setStrengthOptions(haveRulesPassed) {
		this.options.strong.color = haveRulesPassed
			? this.colorStrong
			: this.colorMedium;

		this.options.strong.text = haveRulesPassed
			? this.strengthTextStrong
			: this.strengthTextMedium;
	}

	showStrengthText() {
		const { strengthMsg, showStrengthIndicatorClass } = this;

		if (this.result.scorePercentage > 0) {
			strengthMsg.classList.add(showStrengthIndicatorClass);
		} else {
			strengthMsg.classList.remove(showStrengthIndicatorClass);
		}
	}
}

export default PasswordStrength;
